import React, { Component } from 'react';
import { bool, func, oneOf } from 'prop-types';
import { values } from 'ramda';
import styled from 'styled-components';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import { CancelToken } from 'axios';

import {
  ExportFileFormat,
  ExportSource,
  ExportTimeSource,
} from '../../constants';
import { Note } from '../Text';
import DataExport from './DataExport';

const GoldenButton = styled(FlatButton)`
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.grey500 : theme.colors.gold500} !important;
`;

export class DataExportDialog extends Component {
  render() {
    const {
      open,
      doClose,
      handleDownloads,
      downloadsPending,
      downloadsFailed,
      exportDisabled,
      cancelDialog,
      ...rest
    } = this.props;

    return (
      <Dialog
        open={open}
        title="Export Data"
        autoScrollBodyContent={true}
        actions={[
          downloadsFailed ? (
            <Note style={{ position: 'absolute', left: 24, bottom: 12 }}>
              Can't load the file
            </Note>
          ) : null,

          <GoldenButton
            label="Cancel"
            onClick={() => cancelDialog(this.cancelSource)}
          />,

          <GoldenButton
            disabled={exportDisabled}
            label={
              downloadsPending ? null : downloadsFailed ? 'Retry' : 'Export'
            }
            icon={
              downloadsPending ? (
                <CircularProgress size={30} thickness={3} />
              ) : null
            }
            onClick={() => {
              this.cancelSource = CancelToken.source();
              handleDownloads(this.cancelSource);
            }}
          />,
        ]}
        modal={false}
        onRequestClose={doClose}
        contentStyle={{ maxWidth: 500 }}
        titleStyle={{
          fontSize: '18px',
          fontWeight: 700,
          padding: '15px 24px 12px 24px',
        }}
      >
        <DataExport {...rest} />
      </Dialog>
    );
  }
}

DataExportDialog.propTypes = {
  open: bool.isRequired,
  doClose: func.isRequired,
  exportDisabled: bool.isRequired,
  downloadsPending: bool.isRequired,
  downloadsFailed: bool.isRequired,
  cancelDialog: func.isRequired,
  handleDownloads: func.isRequired,
  includeDataset: bool.isRequired,
  fileFormat: oneOf(values(ExportFileFormat)).isRequired,
  exportSource: oneOf(values(ExportSource)).isRequired,
  timeSource: oneOf(values(ExportTimeSource)).isRequired,
  includeMetadata: bool.isRequired,
  setIncludeDataset: func.isRequired,
  setFileFormat: func.isRequired,
  setExportSource: func.isRequired,
  setTimeSource: func.isRequired,
  setIncludeMetadata: func.isRequired,
};

export default DataExportDialog;



// WEBPACK FOOTER //
// ./src/components/DataExport/DataExportDialog.jsx